/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, ReactNode, ReactNodeArray } from 'react'
import { ContextMenuConfigType } from '@shared/types'
import { BreadCrumbsActionsContext, BreadCrumbsContext } from '@shared/lib'

const BreadCrumbsProvider = ({ children }: { children: ReactNode | ReactNodeArray }) => {
  const [breadCrumbs, setBreadCrumbs] = useState({ currentPath: '', contextMenuConfig: null })

  const [breadCrumbsActions] = useState({
    setBreadCrumbs: (currentPath: string, contextMenuConfig: ContextMenuConfigType[]) =>
      // @ts-ignore
      setBreadCrumbs((prevState) => ({ ...prevState, currentPath, contextMenuConfig })),
  })

  return (
    // @ts-ignore
    <BreadCrumbsContext.Provider value={breadCrumbs}>
      <BreadCrumbsActionsContext.Provider value={breadCrumbsActions}>{children}</BreadCrumbsActionsContext.Provider>
    </BreadCrumbsContext.Provider>
  )
}

export default BreadCrumbsProvider
